// Bundle velho depois de um deploy: o JS já carregado no navegador aponta pra chunks
// com hash que sumiram no build novo. O import() de uma página falha (404) ou recebe
// o index.html no lugar do chunk. A saída é recarregar UMA vez pra pegar o index novo;
// a flag no sessionStorage evita loop se o problema persistir (ex.: servidor fora).

const FLAG = '__konq_reload_apos_preload_error';

// Falha do import() dinâmico em si (Chrome, Firefox, Safari e o webpack antigo).
const ERRO_DE_CHUNK =
  /dynamically imported module|Importing a module script failed|error loading dynamically imported|Loading chunk \d+ failed/i;

// Chunk que voltou como HTML só quebra na hora de usar o módulo — aparece no render.
const ERRO_DE_RENDER =
  /reading 'default'|Cannot destructure property 'default'|Unexpected token '<'|Failed to fetch dynamically/i;

const mensagemDe = (erro) => (erro instanceof Error ? erro.message : String(erro ?? ''));

export const ehErroDeChunkStale = (erro) => ERRO_DE_CHUNK.test(mensagemDe(erro));
export const ehErroDeRenderStale = (erro) => ERRO_DE_RENDER.test(mensagemDe(erro));

/** Recarrega a página se ainda não tentou nesta sessão. Devolve true quando recarregou. */
export function recarregarBundleStale() {
  if (sessionStorage.getItem(FLAG)) return false;
  sessionStorage.setItem(FLAG, '1');
  window.location.reload();
  return true;
}

/** Ouve os sinais de chunk velho no app inteiro. Chamar uma vez, no index. */
export function instalarRecuperacaoDeBundleStale() {
  // Sinal nativo do Vite no preload; o preventDefault evita o rethrow (menos ruído no Sentry).
  window.addEventListener('vite:preloadError', (evento) => {
    evento.preventDefault();
    recarregarBundleStale();
  });
  // import() que falha fora do preload chega como error/unhandledrejection.
  window.addEventListener('error', (evento) => {
    if (ehErroDeChunkStale(evento?.message)) recarregarBundleStale();
  });
  window.addEventListener('unhandledrejection', (evento) => {
    if (ehErroDeChunkStale(evento?.reason)) recarregarBundleStale();
  });
  // Carregou e ficou de pé por alguns segundos: libera a flag pro próximo deploy da sessão.
  window.addEventListener('load', () => {
    setTimeout(() => sessionStorage.removeItem(FLAG), 10000);
  });
}
